module.exports = __webpack_public_path__ + "img/IMG_1137.07e10a98.png";